export const PROJECT_DASHBOARD_TYPE__UNSUPPORTED = 'unsupported'; // this is used as a placeholder value for archived legacy dashboards
export const PROJECT_DASHBOARD_TYPE__ANALYTICS = 'analytics';
export const PROJECT_DASHBOARD_TYPE__ANALYTICS_WITHOUT_POPULATION =
  'analyticsWithoutPopulation';
export const PROJECT_DASHBOARD_TYPE__TIMELINE = 'timeline';
export const PROJECT_DASHBOARD_TYPE__DOCUMENTS = 'documents'; // all completed answer sheets generated for the patient
export const PROJECT_DASHBOARD_TYPE__DETAILS = 'details'; // show detailed information about the entity
export const PROJECT_DASHBOARD_TYPE__LATEST_RESPONSES = 'latestResponses'; // show latest responses for given patient and questionnaire
export const PROJECT_DASHBOARD_TYPE__ANALYTICS_TABLE = 'analyticsTable';
export const PROJECT_DASHBOARD_TYPE__EAPP = 'EAPP';
export const PROJECT_DASHBOARD_TYPE__EAPP_DASHBOARD_V2 = 'EAPPv2';
export const PROJECT_DASHBOARD_TYPE__PROJECT_LANDING_PAGE =
  'projectLandingPage';
export const PROJECT_DASHBOARD_TYPE__PRESET = 'preset';
export const PROJECT_DASHBOARD_TYPE__FUNCTION = 'function';

export const PROJECT_DASHBOARD_TYPES = [
  PROJECT_DASHBOARD_TYPE__UNSUPPORTED,
  PROJECT_DASHBOARD_TYPE__ANALYTICS,
  PROJECT_DASHBOARD_TYPE__ANALYTICS_WITHOUT_POPULATION,
  PROJECT_DASHBOARD_TYPE__TIMELINE,
  PROJECT_DASHBOARD_TYPE__DOCUMENTS,
  PROJECT_DASHBOARD_TYPE__DETAILS,
  PROJECT_DASHBOARD_TYPE__LATEST_RESPONSES,
  PROJECT_DASHBOARD_TYPE__ANALYTICS_TABLE,
  PROJECT_DASHBOARD_TYPE__EAPP,
  PROJECT_DASHBOARD_TYPE__EAPP_DASHBOARD_V2,
  PROJECT_DASHBOARD_TYPE__PROJECT_LANDING_PAGE,
  PROJECT_DASHBOARD_TYPE__PRESET,
  PROJECT_DASHBOARD_TYPE__FUNCTION,
];

export const DASHBOARD_PERSPECTIVE__PATIENTS = 'patients';
export const DASHBOARD_PERSPECTIVE__PARTICIPATIONS = 'participations';
export const DASHBOARD_PERSPECTIVE__ACTIVITIES = 'activities';
export const DASHBOARD_PERSPECTIVE__RESPONSES = 'responses'; // only completed answers sheets
export const DASHBOARD_PERSPECTIVE__ASSIGNMENTS = 'assignments'; // all answers sheets which are "due"
export const DASHBOARD_PERSPECTIVE__ANSWERS = 'answers';
export const DASHBOARD_PERSPECTIVE__EAPPS = 'eapps';
export const DASHBOARD_PERSPECTIVES = [
  DASHBOARD_PERSPECTIVE__PATIENTS,
  DASHBOARD_PERSPECTIVE__PARTICIPATIONS,
  DASHBOARD_PERSPECTIVE__ACTIVITIES,
  DASHBOARD_PERSPECTIVE__RESPONSES,
  DASHBOARD_PERSPECTIVE__ASSIGNMENTS,
  DASHBOARD_PERSPECTIVE__ANSWERS,
  DASHBOARD_PERSPECTIVE__EAPPS,
];

export const DETAILED_VIEW_TRANSFORMATION__DEFAULT = 'default';
export const DETAILED_VIEW_TRANSFORMATION__NOTHING = 'nothing';
export const DETAILED_VIEW_TRANSFORMATION__COLORS = 'colors';
export const DETAILED_VIEW_TRANSFORMATION__OPACITY = 'opacity';
export const DETAILED_VIEW_TRANSFORMATION__PATTERN = 'pattern';
export const DETAILED_VIEW_TRANSFORMATIONS = [
  DETAILED_VIEW_TRANSFORMATION__DEFAULT,
  DETAILED_VIEW_TRANSFORMATION__NOTHING,
  DETAILED_VIEW_TRANSFORMATION__COLORS,
  DETAILED_VIEW_TRANSFORMATION__OPACITY,
  DETAILED_VIEW_TRANSFORMATION__PATTERN,
];
export const TRANSFORMATION_OPACITY__POPULATION = 0.1;
export const TRANSFORMATION_OPACITY__RECIPIENT = 1;
export const TRANSFORMATION_COLORS__POPULATION = 'lightgrey';
export const TRANSFORMATION_COLORS__RECIPIENT = 'skyblue';

export const PATIENT_AUTH_FALLBACK_TYPE__DO_NOT_CONTACT = 'doNotContact';
export const PATIENT_AUTH_FALLBACK_TYPE__CONTACT_AND_SKIP_AUTH =
  'contactAndSkipAuth';
export const PATIENT_AUTH_FALLBACK_TYPE__CONTACT_AND_FAIL_TO_AUTH =
  'contactAndFailToAuth';
export const PATIENT_AUTH_FALLBACK_TYPES = [
  PATIENT_AUTH_FALLBACK_TYPE__DO_NOT_CONTACT,
  PATIENT_AUTH_FALLBACK_TYPE__CONTACT_AND_SKIP_AUTH,
  PATIENT_AUTH_FALLBACK_TYPE__CONTACT_AND_FAIL_TO_AUTH,
];

export const REPORT_TYPE__RESPONSES_DOWNLOAD = 'responses-download';
export const REPORT_TYPE__EAPPS_ALERT_SUMMARY_SINGLE_DOWNLOAD =
  'eapps-alert-summary-single-download';
export const REPORT_TYPE__EAPPS_ALERT_SUMMARY_PATIENT_DOWNLOAD =
  'eapps-alert-summary-patient-download';
export const REPORT_TYPE__EAPPS_ALERT_DIGEST_MAIL = 'eapps-alert-digest-mail';
export const REPORT_TYPE__GENERAL_REPORT_MAIL = 'general-report-mail';

export const isMailReportType = (reportType) => {
  if (!reportType) {
    return false;
  }
  return (
    reportType === REPORT_TYPE__EAPPS_ALERT_DIGEST_MAIL ||
    reportType === REPORT_TYPE__GENERAL_REPORT_MAIL
  );
};

export const REPORT_TYPES = [
  REPORT_TYPE__RESPONSES_DOWNLOAD,
  REPORT_TYPE__EAPPS_ALERT_SUMMARY_SINGLE_DOWNLOAD,
  REPORT_TYPE__EAPPS_ALERT_SUMMARY_PATIENT_DOWNLOAD,
  REPORT_TYPE__EAPPS_ALERT_DIGEST_MAIL,
  REPORT_TYPE__GENERAL_REPORT_MAIL,
];

export const PDF_SECTION_TYPE__CONTAINER = 'container';
export const PDF_SECTION_TYPE__IMAGE = 'image';
export const PDF_SECTION_TYPE__TEXT = 'text';
export const PDF_SECTION_TYPE__CHART = 'chart';
export const PDF_SECTION_TYPE__PATIENT_INFO = 'patient-info';
export const PDF_SECTION_TYPE__PATIENT_RESPONSES = 'patient-responses';
export const PDF_SECTION_TYPE__ALERT_SINGLE_DETAILS = 'alert-single-details';
export const PDF_SECTION_TYPE__ALERT_SINGLE_ASSIGNMENT_HISTORY =
  'alert-single-assignment-history';
export const PDF_SECTION_TYPE__ALERT_SINGLE_NOTES = 'alert-single-notes';
export const PDF_SECTION_TYPE__ALERT_SUMMARY_PATIENT = 'alert-summary-patient';
export const PDF_SECTION_TYPE__ALERTS_DIGEST = 'alerts-digest';

export const PDF_SECTION_TYPES = {
  CONTAINER: PDF_SECTION_TYPE__CONTAINER,
  IMAGE: PDF_SECTION_TYPE__IMAGE,
  TEXT: PDF_SECTION_TYPE__TEXT,
  CHART: PDF_SECTION_TYPE__CHART,
  PATIENT_INFO: PDF_SECTION_TYPE__PATIENT_INFO,
  PATIENT_RESPONSES: PDF_SECTION_TYPE__PATIENT_RESPONSES,
  ALERT_SINGLE_DETAILS: PDF_SECTION_TYPE__ALERT_SINGLE_DETAILS,
  ALERT_SINGLE_ASSIGNMENT_HISTORY:
    PDF_SECTION_TYPE__ALERT_SINGLE_ASSIGNMENT_HISTORY,
  ALERT_SINGLE_NOTES: PDF_SECTION_TYPE__ALERT_SINGLE_NOTES,
  ALERT_SUMMARY_PATIENT: PDF_SECTION_TYPE__ALERT_SUMMARY_PATIENT,
  ALERTS_DIGEST: PDF_SECTION_TYPE__ALERTS_DIGEST,
};
